import elipseGreen from '../../../assets/elipses/elipseGreen.png'
import elipseOrange from '../../../assets/elipses/elipseOrange.png'
import elipsePurple from '../../../assets/elipses/elipsePurple.png'
import elipseRed from '../../../assets/elipses/elipseRed.png'
import elipseYellow from '../../../assets/elipses/elipseYellow.png'
import circleGreen from '../../../assets/circles/circleGreen.png'
import circlePurple from '../../../assets/circles/circlePurple.png'
import circleBlue from '../../../assets/circles/circleBlue.png'
import circleRed from '../../../assets/circles/circleRed.png'
import verticalLine from '../../../assets/others/verticalLine.png'

const elipses = {
    elipseGreen,
    elipseOrange,
    elipsePurple,
    elipseRed,
    elipseYellow,
}

const circles = {
   circleGreen,
   circlePurple,
   circleBlue,
   circleRed,
}

const others = {
    verticalLine,
}

export {elipses, circles, others};